import { gql } from '@apollo/client';

export const GQL_SEND_EXPORT_DATA = gql`
  mutation sendExportData($input: ExportDataInput!) {
    sendExportData(input: $input) {
      status
      message
    }
  }
`;
